export default __webpack_public_path__ + "static/media/31.1f775600.png";